import React from 'react'
import PropTypes from 'prop-types'

const EnFlagIcon = ({ size = '36' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <path d="M32.3668 11.0347H34V10.0961V9.92389L32.3668 11.0347Z" fill="#000D7F" />
      <path
        d="M21.489 34.0045H29.6935C30.3927 34.0035 31.0811 33.8316 31.699 33.5037C32.3169 33.1759 32.8456 32.7019 33.2392 32.123L33.3424 31.9594L21.489 24.0676V34.0045Z"
        fill="#000D7F"
      />
      <path d="M34 24.2181V23.865V23.0341H32.2637L34 24.2181Z" fill="#000D7F" />
      <path
        d="M33.3768 2.09674C33.3259 2.00746 33.27 1.92122 33.2092 1.83843C32.8136 1.27168 32.2876 0.808727 31.6757 0.488723C31.0637 0.168719 30.3838 0.00107616 29.6935 0H21.489V10.0489L33.3768 2.09674Z"
        fill="#000D7F"
      />
      <path d="M0 9.79919V11.0349H1.89534L0 9.79919Z" fill="#000D7F" />
      <path
        d="M12.4422 0H4.31935C3.58231 0.00131072 2.85798 0.192489 2.21597 0.555155C1.57396 0.917821 1.03585 1.43976 0.65332 2.07089L12.4422 9.94123V0Z"
        fill="#000D7F"
      />
      <path
        d="M0.661865 31.9463C0.696248 32.0065 0.726328 32.0668 0.765009 32.1228C1.16081 32.7016 1.69116 33.1753 2.31035 33.503C2.92954 33.8308 3.61899 34.0028 4.31931 34.0043H12.4422V24.0501L0.661865 31.9463Z"
        fill="#000D7F"
      />
      <path d="M0 23.0341V23.865V24.1793L1.66755 23.0341H0Z" fill="#000D7F" />
      <path
        d="M14.2473 0H12.4422V9.94123L0.653276 2.07089C0.601702 2.15269 0.545828 2.23453 0.50285 2.32063C0.266195 2.76909 0.110509 3.2559 0.0429808 3.75863C0.0155222 3.94685 0.00115894 4.13677 0 4.32698V5.68315L8.03261 11.0348H3.9454L0 8.39559V9.79917L1.89534 11.0348H0V13.3598H14.2473V0Z"
        fill="white"
      />
      <path
        d="M34.0042 9.92404V5.75636L26.208 11.0348H21.9102L33.828 3.06116C33.7263 2.72268 33.5819 2.39859 33.3983 2.09674L21.5105 10.0489V0H19.6667V13.3468H34.0128V11.0219H32.3754L34.0042 9.92404Z"
        fill="white"
      />
      <path
        d="M19.6667 34.0044H21.4976V24.0674L33.351 31.9593C33.7809 31.2759 34.0103 30.4851 34.0128 29.6774V28.304L26.1135 23.0298H30.2136L34 25.5614V24.2138L32.2808 23.0298H34V20.5757H19.6667V34.0044Z"
        fill="white"
      />
      <path
        d="M0 20.58V23.034H1.67186L0 24.1793V28.3469L7.95956 23.0297H12.0854L0.223495 31.0206C0.299488 31.2499 0.392877 31.473 0.50285 31.6879C0.550126 31.7784 0.605995 31.8645 0.661867 31.9506L12.4422 24.0544V34.0086H14.2473V20.5842L0 20.58Z"
        fill="white"
      />
      <path
        d="M19.6539 0H18.2958H18.2227H14.243V13.3598H0V15.4307V16.8902V17.0022V18.3541V20.58H14.243V34H19.6539V20.58H34V18.3541V17.0022V15.6029V13.3598H19.6539V0Z"
        fill="#D41800"
      />
      <path
        d="M8.03261 11.0349L0 5.68329V7.68531V8.22349V8.39571L3.94109 11.0349H8.03261Z"
        fill="#D41800"
      />
      <path
        d="M26.2081 11.0348L34.0043 5.7563V4.32692C34.004 3.89762 33.9388 3.47082 33.8109 3.0611L21.8931 11.0348H26.2081Z"
        fill="#D41800"
      />
      <path
        d="M7.95956 23.0299L0 28.3427V29.6732C0.00334143 30.1285 0.0787828 30.5805 0.223495 31.0121L12.0854 23.0212L7.95956 23.0299Z"
        fill="#D41800"
      />
      <path
        d="M26.1178 23.0384L34 28.3039V26.6162V25.7766V25.5657L30.2179 23.0341L26.1178 23.0384Z"
        fill="#D41800"
      />
    </svg>
  )
}

export default React.memo(EnFlagIcon)

EnFlagIcon.propTypes = {
  size: PropTypes.any,
}
